export const HIGHLIGHT_STRUCTURE = {

	Punch: {
		Other: ['Spinning Back Fist', 'Superman Punch', 'Overhand Punch']
	},
	Elbow: {
		Other: ['Spinning Elbow']
	},
	Knee: {
		Other: ['Flying Knee']
	},
	Cross: {
		Other: ['Spinning Back Fist', 'Superman Punch']
	},
	UL: {
		Other: ['Liver Punch']
	},
	UR: {
		Other: ['Liver Punch']
	},
	HL: {
		Other: ['Liver Punch', 'Overhand Punch']
	},
	HR: {
		Other: ['Liver Punch', 'Overhand Punch']
	},
	Kick: {
		P2: ['Spinning Back Kick',
			'Spinning Side Kick',
			'Spinning Hook Kick',
			'Push Kick',
			'Side Kick',
			'Front Kick',
			'Question Mark Kick',
			'Soccer Kick',
			'Up kick',
			'Liver Kick',
			'Switch Kick'
		],
		P1: [
			'Axe Kick',
			'Front Kick',
			'Question Mark Kick',
			'Spinning Back Kick',
			'Spinning Side Kick',
			'Spinning Hook Kick',
			'Push Kick',
			'Side Kick',
			'Soccer Kick',
			'Up kick',
			'Liver Kick',
			'Switch Kick'
		],
		Other: [
			'Calf Kick',
			'Oblique Kick',
			'Soccer Kick',
			"Thigh Kick",
			'Liver Kick',
			'Switch Kick'
		]
	},
	Takedown: {
		Other: [
			"Double leg",
			"Single leg",
			"Slams",
			"Sweeps",
			"Throws",
			"Suplex"]
	},
	Transition: {
		Other: ["Double leg", "Single leg", 'Body']
	},
	Submission: {
		P1: ['Rear Naked Choke', 'Triangle Choke', 'Anaconda Choke', 'Arm Triangle', 'D’Arce Choke', 'Forearm Choke', 'Guillotine Choke', 'Neck Crank', 'North-South Choke', 'Peruvian Necktie', 'Avon Flue Choke'],
		P3: ['Armbar', 'Hammerlock', 'Keylock', 'Kimura', 'Omoplata'],
		P4: ['Armbar', 'Hammerlock', 'Keylock', 'Kimura', 'Omoplata'],
		P5: ['Ankle Lock', 'Heel Hook', 'Kneebar', 'Toe Hold'],
		P6: ['Ankle Lock', 'Heel Hook', 'Kneebar', 'Toe Hold'],
		Other: ['Gi Choke', 'Gogo Plata', 'Injury', 'Other', 'Gogoplata'],
	},
	Position: {}

};

export function getNameAction(hlDesc: string)
{
	for (let res in HIGHLIGHT_STRUCTURE)
	{
		for (let arrName in HIGHLIGHT_STRUCTURE[res])
		{
			if (HIGHLIGHT_STRUCTURE[res][arrName].indexOf(hlDesc) > -1)
				return res;
		}
	}
	return null;
}